export enum LoginSearchPramas {
  Message = 'message',
  Severity = 'severity',
  Url = 'url',
}
